import React, { useEffect, useRef } from 'react'
import { motion, useAnimationControls, useInView } from "motion/react"

const Reveal = ({ children }) => {

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    const controls = useAnimationControls();

    useEffect(() => {
        if (isInView) {
            controls.start("visible");
        }
    }, [isInView, controls]);

    return (
        <div>
            <div ref={ref}>
                <motion.div
                    variants={{
                        hidden: { opacity: 0, y: 75 },
                        visible: { opacity: 1, y: 0 },
                    }}
                    initial="hidden"
                    animate={controls}
                    transition={{ duration: 0.5, delay: 0.25 }}
                >
                    {children}
                </motion.div>
            </div>
        </div>
    )
}

export default Reveal